module.exports = __webpack_public_path__ + "static/tower_static-08b4507e29826780f1394a45f9216f28.png";